export const acceptanceTerms = `
  .title {
    font-size: 14px;
    color: #6e798e;
    font-weight: 600;
  }

  .checkbox {
    display: flex;

    a {
      cursor: pointer;
      color: #1ABC9C;
    }
  }
`;

export const acceptanceTermsModal = `
  h1, h2, h3, h4, h5, h6 {
    color: #223254;
    font-weight: bold;
  }

  h1, h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  h4, h5, h6 {
    font-size: 14px;
  }
`;